const ALIYUN_CAPTCHA_SCRIPT = 'https://o.alicdn.com/captcha-frontend/aliyunCaptcha/AliyunCaptcha.js'

const ALIYUN_REGISTER_CAPTCHA_CONFIG = {
  region: 'sgp',
  prefix: 'jzwubu',
  sceneId: '14r5m91g',
  script: ALIYUN_CAPTCHA_SCRIPT
}

let scriptPromise = null
let captchaInitPromise = null
const captchaInitPromiseMap = {}

function getAliyunCaptchaCacheKey(config, options = {}) {
  return options.cacheKey || `${config.sceneId}|${options.element || ''}|${options.button || ''}`
}

function add32(a, b) {
  return (a + b) & 0xffffffff
}

function leftRotate(value, shift) {
  return (value << shift) | (value >>> (32 - shift))
}

function toUtf8Bytes(input) {
  return unescape(encodeURIComponent(input))
}

function wordToHex(value) {
  let output = ''
  for (let i = 0; i < 4; i++) {
    output += ((value >>> (i * 8)) & 255).toString(16).padStart(2, '0')
  }
  return output
}

function md5(input) {
  const str = toUtf8Bytes(input)
  const x = []
  const k = []
  const s = [
    7, 12, 17, 22, 7, 12, 17, 22, 7, 12, 17, 22, 7, 12, 17, 22,
    5, 9, 14, 20, 5, 9, 14, 20, 5, 9, 14, 20, 5, 9, 14, 20,
    4, 11, 16, 23, 4, 11, 16, 23, 4, 11, 16, 23, 4, 11, 16, 23,
    6, 10, 15, 21, 6, 10, 15, 21, 6, 10, 15, 21, 6, 10, 15, 21
  ]

  for (let i = 0; i < 64; i++) {
    k[i] = Math.floor(Math.abs(Math.sin(i + 1)) * 4294967296)
  }

  for (let i = 0; i < str.length; i++) {
    x[i >> 2] |= str.charCodeAt(i) << ((i % 4) * 8)
  }

  x[str.length >> 2] |= 0x80 << ((str.length % 4) * 8)
  x[(((str.length + 8) >> 6) + 1) * 16 - 2] = str.length * 8

  let a = 0x67452301
  let b = 0xefcdab89
  let c = 0x98badcfe
  let d = 0x10325476

  for (let i = 0; i < x.length; i += 16) {
    const aa = a
    const bb = b
    const cc = c
    const dd = d

    for (let j = 0; j < 64; j++) {
      let f
      let g

      if (j < 16) {
        f = (b & c) | (~b & d)
        g = j
      } else if (j < 32) {
        f = (d & b) | (~d & c)
        g = (5 * j + 1) % 16
      } else if (j < 48) {
        f = b ^ c ^ d
        g = (3 * j + 5) % 16
      } else {
        f = c ^ (b | ~d)
        g = (7 * j) % 16
      }

      const temp = d
      d = c
      c = b
      b = add32(b, leftRotate(add32(add32(a, f), add32(k[j], x[i + g] || 0)), s[j]))
      a = temp
    }

    a = add32(a, aa)
    b = add32(b, bb)
    c = add32(c, cc)
    d = add32(d, dd)
  }

  return `${wordToHex(a)}${wordToHex(b)}${wordToHex(c)}${wordToHex(d)}`
}

function isAliyunCaptchaConfigured(config = ALIYUN_REGISTER_CAPTCHA_CONFIG) {
  return !!(config.region && config.prefix && config.sceneId)
}

// 加載阿里雲人機驗證脚本
function loadAliyunCaptchaScript(script = ALIYUN_CAPTCHA_SCRIPT) {
  if (window.initAliyunCaptcha) {
    return Promise.resolve()
  }

  if (scriptPromise) {
    return scriptPromise
  }

  const existingScript = document.querySelector(`script[src="${script}"]`)
  if (existingScript) {
    scriptPromise = new Promise((resolve, reject) => {
      existingScript.addEventListener('load', resolve, { once: true })
      existingScript.addEventListener('error', reject, { once: true })
    })
    return scriptPromise
  }

  scriptPromise = new Promise((resolve, reject) => {
    const scriptElement = document.createElement('script')
    scriptElement.src = script
    scriptElement.async = true
    scriptElement.onload = resolve
    scriptElement.onerror = reject
    document.head.appendChild(scriptElement)
  })

  return scriptPromise
}

// 初始化人機驗證
function initAliyunCaptcha(options = {}) {
  const config = options.config || ALIYUN_REGISTER_CAPTCHA_CONFIG
  const cacheKey = getAliyunCaptchaCacheKey(config, options)

  if (captchaInitPromiseMap[cacheKey]) {
    return captchaInitPromiseMap[cacheKey]
  }

  window.AliyunCaptchaConfig = {
    region: config.region,
    prefix: config.prefix
  }

  captchaInitPromise = loadAliyunCaptchaScript(config.script).then(() => {
    if (!window.initAliyunCaptcha) {
      throw new Error('Aliyun CAPTCHA script loaded without initAliyunCaptcha')
    }

    return new Promise((resolve) => {
      window.initAliyunCaptcha({
        SceneId: config.sceneId,
        language: options.language,
        captchaLogoImg: options.captchaLogoImg,
        mode: options.mode || 'popup',
        element: options.element,
        button: options.button,
        captchaVerifyCallback: options.captchaVerifyCallback,
        onBizResultCallback: options.onBizResultCallback,
        fail: options.fail,
        getInstance: (instance) => {
          if (typeof options.getInstance === 'function') {
            options.getInstance(instance)
          }
          resolve(instance)
        }
      })
    })
  }).catch((error) => {
    console.log('初始化失敗：', error)
    delete captchaInitPromiseMap[cacheKey]
    captchaInitPromise = null
    throw error
  })

  captchaInitPromiseMap[cacheKey] = captchaInitPromise

  return captchaInitPromise
}

function resetAliyunCaptcha(options = {}, instance) {
  const config = options.config || ALIYUN_REGISTER_CAPTCHA_CONFIG
  const cacheKey = getAliyunCaptchaCacheKey(config, options)

  if (instance && typeof instance.refresh === 'function') {
    instance.refresh()
    return true
  }

  if (instance && typeof instance.destroyCaptcha === 'function') {
    instance.destroyCaptcha()
  }

  delete captchaInitPromiseMap[cacheKey]
  captchaInitPromise = null
  return false
}

// 生成瀏覽器指紋
function buildBrowserFingerprint() {
  const screenInfo = window.screen || {}
  const navigatorInfo = window.navigator || {}

  return [
    navigatorInfo.userAgent || '',
    navigatorInfo.language || '',
    Array.isArray(navigatorInfo.languages) ? navigatorInfo.languages.join(',') : '',
    navigatorInfo.platform || '',
    navigatorInfo.vendor || '',
    navigatorInfo.hardwareConcurrency || '',
    navigatorInfo.deviceMemory || '',
    navigatorInfo.cookieEnabled ? '1' : '0',
    navigatorInfo.doNotTrack || '',
    screenInfo.width || '',
    screenInfo.height || '',
    screenInfo.colorDepth || '',
    new Date().getTimezoneOffset(),
    Intl.DateTimeFormat().resolvedOptions().timeZone || ''
  ].join('|')
}

function getBrowserFingerprintsMd5() {
  return md5(buildBrowserFingerprint())
}

export {
  ALIYUN_CAPTCHA_SCRIPT,
  ALIYUN_REGISTER_CAPTCHA_CONFIG,
  buildBrowserFingerprint,
  getBrowserFingerprintsMd5,
  initAliyunCaptcha,
  isAliyunCaptchaConfigured,
  loadAliyunCaptchaScript,
  resetAliyunCaptcha
}
